import React, { useEffect } from "react";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import posthog, { initPostHog } from "../services/posthog";

const PostHogProvider = ({ children }) => {
  useEffect(() => {
    initPostHog();
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};

export default PostHogProvider;